import { Message } from 'element-ui'
import { fetchAppModules } from '@/api/account'

// 左侧主导航 / 模块名 对应 t_roles_tree 一级节点
const MENU_MODULES = {
  browser: ['数据服务'],
  mqtt: ['IOT管理'],
  cloud: ['云函数'],
  fileManager: ['素材管理'],
  material: ['素材管理'],
  staticSite: ['素材管理'],
  appPay: ['收益管理'],
  sms: ['短信服务'],
  pushmsg: ['消息推送'],
  analysis: ['统计分析'],
  secret: ['应用设置', '套餐升级', 'AI设置'],
  edit: ['应用设置'],
  appauth: ['应用设置'],
  domain: ['应用设置'],
  backuprestore: ['应用设置'],
  config: ['应用设置'],
  setemail: ['应用设置'],
  aiset: ['AI设置', '应用设置'],
  dataHook: ['应用设置', '云函数'],
  upgrade: ['套餐升级', '应用设置']
}

let cache = {
  appId: '',
  isOwner: true,
  modules: ['*'],
  loading: null
}

function pick(row, ...keys) {
  for (let i = 0; i < keys.length; i++) {
    if (row[keys[i]] !== undefined && row[keys[i]] !== null) {
      return row[keys[i]]
    }
  }
  return ''
}

export function loadAppPermission(appId) {
  const id = String(appId || '')
  if (!id) {
    cache = { appId: '', isOwner: true, modules: ['*'], loading: null }
    return Promise.resolve(cache)
  }
  if (cache.appId === id && cache.loading === null) {
    return Promise.resolve(cache)
  }
  if (cache.appId === id && cache.loading) {
    return cache.loading
  }
  cache.appId = id
  cache.loading = fetchAppModules(id).then(res => {
    const data = (res && res.data) || {}
    const isOwner = !!pick(data, 'isOwner', 'IsOwner')
    let modules = pick(data, 'modules', 'Modules') || []
    if (!Array.isArray(modules)) {
      modules = []
    }
    cache = {
      appId: id,
      isOwner,
      modules,
      loading: null
    }
    return cache
  }).catch(() => {
    // 接口失败时不阻断所有者；协作成员按无权限处理更安全
    cache = {
      appId: id,
      isOwner: false,
      modules: [],
      loading: null
    }
    return cache
  })
  return cache.loading
}

export function clearAppPermission() {
  cache = { appId: '', isOwner: true, modules: ['*'], loading: null }
}

export function canAccessModules(moduleNames) {
  if (cache.isOwner) return true
  if (cache.modules.indexOf('*') !== -1) return true
  const names = Array.isArray(moduleNames) ? moduleNames : [moduleNames]
  return names.some(name => cache.modules.indexOf(name) !== -1)
}

export function canAccessMenu(menuKey) {
  const modules = MENU_MODULES[menuKey]
  if (!modules || !modules.length) {
    // 未映射的菜单，所有者放行；协作成员默认拦截
    return cache.isOwner
  }
  return canAccessModules(modules)
}

export function guardMenu(menuKey, onAllow) {
  if (canAccessMenu(menuKey)) {
    if (typeof onAllow === 'function') onAllow()
    return true
  }
  Message.warning('您没有该功能的访问权限，请联系应用管理员分配权限')
  return false
}

export function resolveMenuKeyByPath(path) {
  const p = String(path || '')
  if (p.includes('/browser')) return 'browser'
  if (p.includes('/mqtt')) return 'mqtt'
  if (p.includes('/cloud') || p.includes('/Cloud') || p.includes('/addCloud')) return 'cloud'
  if (p.includes('/fileManager') || p.includes('/staticSite') || p.includes('/material')) return 'fileManager'
  if (p.includes('/appPay')) return 'appPay'
  if (p.includes('/sms')) return 'sms'
  if (p.includes('/pushmsg')) return 'pushmsg'
  if (p.includes('/analysis')) return 'analysis'
  if (p.includes('/upgrade')) return 'upgrade'
  if (p.includes('/aiset')) return 'aiset'
  if (p.includes('/dataHook')) return 'dataHook'
  if (p.includes('/secret') || p.includes('/edit') || p.includes('/appauth') || p.includes('/domain') || p.includes('/config') || p.includes('/setemail') || p.includes('/backuprestore')) {
    return 'secret'
  }
  return ''
}
